export default __webpack_public_path__ + "static/media/P1010515-1-point-5-768x515.08ce90f1.jpg";